module.exports = __webpack_public_path__ + "static/media/success-icon.77d544ed.png";